import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxesField } from '../../../../../01_atoms/FormElements';
import { DEFAULT_COUNTRY_CODE } from '../../../../../../utils/constants';

import styles from './index.module.scss';
import formattedTextStyles from '../../../../../01_atoms/FormattedText/index.module.scss';

const Preferences = ({ setValue, preferencesToView, addressIsDisplayed }) => (
  <div
    className={`${styles['preferences']} ${
      preferencesToView.length === 1 ? styles['preferences__email-only'] : ''
    }`}
  >
    {preferencesToView.length > 1 && (
      <div className={styles['preferences__multiple-checkboxes']}>
        {DEFAULT_COUNTRY_CODE === 'IE' && (
          <>
            <h3 className={styles['preferences__title']}>We need to stay in touch</h3>
            <p className={styles['preferences__description']}>
              We rely on the generosity of compassionate people like you. Please tick the boxes
              below so we can keep you updated on our work and reach out for your continued support.
              We promise not to spam you, and you can opt out at any time.
            </p>
          </>
        )}

        {DEFAULT_COUNTRY_CODE === 'GB' && (
          <>
            <h3 className={styles['preferences__title']}>Keeping you informed</h3>
            <p className={styles['preferences__description']}>
              We&#39;d love to keep you updated about our vital work tackling extreme poverty and
              how you can help transform more lives through campaigning and appeals.
            </p>
            <p className={styles['preferences__description']}>
              Yes - I want to hear from Concern by:
            </p>
          </>
        )}

        <CheckboxesField
          name="contact_preferences"
          options={preferencesToView}
          label=""
          withBackground
        />
      </div>
    )}

    {preferencesToView.length === 1 && (
      <CheckboxesField
        name="contact_preferences"
        options={[
          {
            value: 'email',
            label: 'I’m happy to hear from you on email',
          },
        ]}
        label=""
        withBackground
      />
    )}
    <p
      className={`${styles['details__small-description']} ${formattedTextStyles['formatted-text']}`}
    >
      {DEFAULT_COUNTRY_CODE === 'IE' &&
        'You may already have opted into some of our marketing, in which case we will continue to rely on that permission. '}
      {DEFAULT_COUNTRY_CODE === 'IE' &&
        addressIsDisplayed &&
        'We will also keep you updated by post. '}
      {DEFAULT_COUNTRY_CODE === 'IE' ? (
        <>
          You can opt out of postal & other marketing by contacting us at{' '}
          <a href="mailto:preferences@concern.net" target="_blank" rel="noopener noreferrer">
            preferences@concern.net
          </a>
          .{' '}
        </>
      ) : (
        <>
          You can change your preferences at any time by contacting us at{' '}
          <a href="mailto:enquiries.info@concern.net" target="_blank" rel="noopener noreferrer">
            enquiries.info@concern.net
          </a>{' '}
          or by calling 0800 032 4001.{' '}
        </>
      )}
      For further information please see our{' '}
      <a
        href={
          DEFAULT_COUNTRY_CODE === 'IE'
            ? 'https://www.concern.net/privacy'
            : 'https://www.concern.org.uk/privacy-statement'
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        privacy policy
      </a>
      .
    </p>
  </div>
);

Preferences.propTypes = {
  setValue: PropTypes.func.isRequired,
  addressIsDisplayed: PropTypes.bool.isRequired,
  preferencesToView: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      valueBackend: PropTypes.string,
      label: PropTypes.string,
      labelON: PropTypes.string,
    }),
  ).isRequired,
};

export default Preferences;
